import { combineReducers } from "@reduxjs/toolkit";
import { gameDetailsSlice } from './game-details';

export default combineReducers({
  details: gameDetailsSlice.reducer,
});
